// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: rgba(0, 0, 0, 0.9);
}
:host ion-header {
  background-color: transparent !important;
}
:host ion-header ion-toolbar {
  --background: transparent !important;
}
:host ion-header ion-toolbar ion-button {
  --cms-header-icon-color: #fff !important;
}
:host ion-header ion-toolbar ion-title {
  color: #fff !important;
}
:host ion-header ion-toolbar .button {
  color: #fff !important;
  background-color: transparent !important;
  position: relative;
  padding: 0 5px;
}
:host .carousel-controls {
  display: none;
}
:host ion-content {
  --background: transparent;
  background-color: transparent !important;
  max-width: unset;
}
:host ion-content .swiper-pagination .swiper-pagination-current {
  color: #fff;
}
:host ion-content .gallery-main-image {
  max-width: 700px;
  height: 100%;
  --bullet-background: #fff;
  --bullet-background-active: #fff;
  --swiper-pagination-fraction-color:#fff !important;
}
:host ion-content .gallery-main-image swiper-slide {
  display: flex;
  flex-direction: column;
}
:host ion-content .gallery-main-image swiper-slide .main-image {
  width: 100%;
  min-height: calc(60vh - 44px);
  max-height: 58vh;
  object-fit: contain;
  object-position: center;
}
:host ion-content .gallery-main-image swiper-slide .swiper-zoom-container {
  min-height: calc(60vh - 44px);
  max-height: 58vh;
}
:host ion-content .gallery-main-image swiper-slide toolbar-comments-likes {
  width: 100%;
}
:host ion-content .gallery-main-image swiper-slide .vertical {
  aspect-ratio: 9/16;
  width: 100%;
}
:host ion-content .gallery-main-image swiper-slide .vertical .main-image {
  object-fit: cover;
  min-height: unset;
  max-height: unset;
  height: 100%;
}
:host .gallery-thumbnails {
  display: flex;
  align-items: flex-end;
  background-color: transparent;
}
:host .gallery-thumbnails swiper-container {
  display: block;
  width: 100%;
  height: 100%;
}
:host .gallery-thumbnails swiper-container swiper-slide {
  height: 22vw;
  padding: 10px 0px 10px 10px;
}
:host .gallery-thumbnails swiper-container swiper-slide img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
:host toolbar-comments-likes ::ng-deep ion-icon {
  color: white;
}
:host toolbar-comments-likes ::ng-deep ion-icon.filled-heart {
  color: #ed4956;
}
:host toolbar-comments-likes ::ng-deep a, :host toolbar-comments-likes ::ng-deep span {
  color: white !important;
}
:host .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}
:host .is-video.slideSmall .icon-play {
  height: 25px;
  width: 25px;
  top: calc(50% - 13px);
  padding: 5px 3px 5px 7px;
  left: calc(50% - 17px);
}

:host-context(.plt-desktop) {
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
}
:host-context(.plt-desktop) .gallery-thumbnails swiper-container swiper-slide {
  height: 150px;
}
:host-context(.plt-desktop) .carousel-controls {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 100;
}
:host-context(.plt-desktop) .carousel-controls ion-button {
  pointer-events: all;
  --padding-start: 0.5rem;
  --padding-end: 0.5rem;
  --background: transparent !important;
  color: var(--ion-color-light);
  font-size: 30px;
}
:host-context(.plt-desktop) .carousel-controls ion-button:hover {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gallery/gallery-modal/gallery-modal.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;AACE;EACE,wCAAA;AACJ;AAAI;EAKE,oCAAA;AAFN;AAFM;EACE,wCAAA;AAIR;AACM;EACE,sBAAA;AACR;AAEM;EACE,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;AAAR;AAKE;EACE,aAAA;AAHJ;AAME;EACE,yBAAA;EACA,wCAAA;EACA,gBAAA;AAJJ;AAOM;EACE,WAAA;AALR;AASI;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,gCAAA;EACA,kDAAA;AAPN;AASM;EACE,aAAA;EACA,sBAAA;AAPR;AAQQ;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AANV;AASQ;EACE,6BAAA;EACA,gBAAA;AAPV;AAUQ;EACE,WAAA;AARV;AAWQ;EACE,kBAAA;EACA,WAAA;AATV;AAUU;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AARZ;AAeE;EACE,aAAA;EACA,qBAAA;EACA,6BAAA;AAbJ;AAeI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAbN;AAeM;EACE,YAAA;EACA,2BAAA;AAbR;AAeQ;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAbV;AAuBM;EACE,YAAA;AArBR;AAsBQ;EACE,cAAA;AApBV;AAuBM;EACE,uBAAA;AArBR;AA4BI;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AA1BN;AAgCI;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;AA9BN;;AAmCA;EACE,8BAAA;EACA,mBAAA;AAhCF;AAsCM;EACE,aAAA;AApCR;AAyCE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AAvCJ;AAyCI;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;AAvCN;AAyCM;EACE,YAAA;AAvCR","sourcesContent":[":host {\n  background: rgba(0, 0, 0, 0.9);\n\n  ion-header {\n    background-color: transparent !important;\n    ion-toolbar {\n      ion-button {\n        --cms-header-icon-color: #fff !important;\n\n      }\n      --background: transparent !important;\n\n      ion-title {\n        color: #fff !important;\n      }\n\n      .button {\n        color: #fff !important;\n        background-color: transparent !important;\n        position: relative;\n        padding: 0 5px;\n      }\n    }\n  }\n\n  .carousel-controls {\n    display: none;\n  }\n\n  ion-content {\n    --background: transparent;\n    background-color: transparent !important;\n    max-width: unset;\n\n    .swiper-pagination {\n      .swiper-pagination-current {\n        color: #fff;\n      }\n    }\n\n    .gallery-main-image {\n      max-width: 700px;\n      height: 100%;\n      --bullet-background: #fff;\n      --bullet-background-active: #fff;\n      --swiper-pagination-fraction-color:#fff !important;\n\n      swiper-slide {\n        display: flex;\n        flex-direction: column;\n        .main-image {\n          width: 100%;\n          min-height: calc(60vh - 44px);\n          max-height: 58vh;\n          object-fit: contain;\n          object-position: center;\n        }\n\n        .swiper-zoom-container {\n          min-height: calc(60vh - 44px);\n          max-height: 58vh;\n        }\n\n        toolbar-comments-likes {\n          width: 100%;\n        }\n\n        .vertical{\n          aspect-ratio: 9/16;\n          width: 100%;\n          .main-image{\n            object-fit: cover;\n            min-height: unset;\n            max-height: unset;\n            height: 100%;\n          }\n        }\n      }\n    }\n  }\n\n  .gallery-thumbnails {\n    display: flex;\n    align-items: flex-end;\n    background-color: transparent;\n\n    swiper-container {\n      display: block;\n      width: 100%;\n      height: 100%;\n\n      swiper-slide {\n        height: 22vw;\n        padding: 10px 0px 10px 10px;\n\n        img {\n          object-fit: cover;\n          object-position: center;\n          width: 100%;\n          height: 100%;\n        }\n      }\n    }\n\n   \n  }\n\n  toolbar-comments-likes {\n    ::ng-deep{\n      ion-icon{\n        color: white;\n        &.filled-heart{\n          color: #ed4956;\n        }\n      }\n      a, span{\n        color: white !important;\n      }\n\n    }\n  }\n\n  .is-video {\n    .icon-play {\n      background-color: white;\n      border-radius: 50%;\n      height: 50px;\n      width: 50px;\n      top: calc(50% - 35px);\n      padding: 10px 7px 10px 13px;\n      left: calc(50% - 35px);\n      position: absolute;\n      box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n      color: var(--ion-color-dark);\n    }\n  }\n\n\n  .is-video.slideSmall {\n    .icon-play {\n      height: 25px;\n      width: 25px;\n      top: calc(50% - 13px);\n      padding: 5px 3px 5px 7px;\n      left: calc(50% - 17px);\n    }\n  }\n}\n\n:host-context(.plt-desktop) {\n  background: rgba(0, 0, 0, 0.8);\n  align-items: center;\n  .gallery-main-image {\n  }\n\n  .gallery-thumbnails {\n    swiper-container {\n      swiper-slide {\n        height: 150px;\n      }\n    }\n  }\n\n  .carousel-controls {\n    position: absolute;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    z-index: 100;\n\n    ion-button {\n      pointer-events: all;\n      --padding-start: 0.5rem;\n      --padding-end: 0.5rem;\n      --background: transparent !important;\n      color: var(--ion-color-light);\n      font-size: 30px;\n\n      &:hover {\n        opacity: 0.5;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
